import React, { useState, useEffect } from "react";
import PageHeading from "../common/PageHeading";

import { BrideIcon, GroomIcon } from "../../utils/SvgComponents";
import { useNavigate, useParams } from "react-router-dom";
import CustomCard from "../common/card/Card";
import FamilyChart from "../family-chart/FamilyChart";
import { apiHandler } from "../../utils/apiHandler";
import { newImgUrl } from "../../utils/Constants";

const Family = () => {
	const { id } = useParams();
	const [family, setFamily] = useState([]);
	const [basicDetails, setBasicDetails] = useState();
	const [openPage, setOpenPage] = useState()
	const [backgroundImageWeb, setBackgroundImageWeb] = useState([]);
	const [backgroundImageMob, setBackgroundImageMob] = useState([]);
	const [currentImageIndexWeb, setCurrentImageIndexWeb] = useState(0);
	const [currentImageIndexMob, setCurrentImageIndexMob] = useState(0);
	const isMobile = window.innerWidth <= 768;
	const [isSlideIn, setIsSlideIn] = useState(false);
	const [isImageLoaded, setIsImageLoaded] = useState(true);
	const [handleSlideInvideo, sethandleSlideInforVideos] = useState(false);
	const navigate = useNavigate();
	let NewUsername = "";

	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		NewUsername = pathArray[1];
	} else {
		NewUsername = pathArray[0]
	}

	let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
	const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
	console.log(newImgUrl);


	useEffect(() => {
		const fetchMeetFamily = async () => {
			console.log("hii")
			try {

				const res = await apiHandler.post("/guest/fetch-feature", {
					_id: id,
					category: "MeetFamily"
				});
				console.log(res);
				if (res) {
					console.log(res)
					setFamily(res);
					setBasicDetails(res.basicDetails);
					setBackgroundImageWeb(res.basicDetails.familyWebBgSlider);
					setBackgroundImageMob(res.basicDetails.familyMobBgSlider);
				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};

		if (family?.length <= 0 && id) {
			fetchMeetFamily();
		}
	}, [id])
	const handleSlideIn = (slug) => {
		console.log("slidein")
		console.log(slug)
		if (!isSlideIn) {
			window.history.pushState({ isSlideIn: true }, "", `/${NewUsername}/FamilyChart/${id}/${slug}`);
		} else {
			window.history.back();
		}
		setOpenPage(slug)
		setIsSlideIn(!isSlideIn);
	};

	useEffect(() => {
		const handlePopState = () => {
			if (isSlideIn) {
				setIsSlideIn(false);
			}
		};
		window.addEventListener("popstate", handlePopState);

		return () => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, [isSlideIn]);

	useEffect(() => {
		if (!isMobile) {
			const interval = setInterval(() => {
				setCurrentImageIndexWeb((prev) =>
					prev === backgroundImageWeb.length - 1 ? 0 : prev + 1
				);
			}, 4000);
			return () => clearInterval(interval);
		}
	}, [isMobile, backgroundImageWeb.length]);

	useEffect(() => {
		if (isMobile) {
			const interval = setInterval(() => {
				setCurrentImageIndexMob((prev) =>
					prev === backgroundImageMob.length - 1 ? 0 : prev + 1
				);
			}, 4000);
			return () => clearInterval(interval);
		}
	}, [isMobile, backgroundImageMob.length]);

	return (
		<div style={{ zIndex: '333333', backgroundColor: 'white' }}>
			<div
				className={`${isSlideIn ? "translate-x-0" : "translate-x-full"
					} fixed top-0 right-0 w-full h-full bg-black/70 z-[100] `}
				style={{
					opacity: isSlideIn ? 1 : 0,
					minHeight: "100svh !important",
					transition: "transform 500ms ease-in-out, opacity 500ms ease-in-out",
				}}
			>
				{openPage && (
					<div className="">
						<FamilyChart checkData={openPage} />
					</div>
				)}
			</div>
			<div className="hidden sm:block h-dvh">

				<div className="relative w-screen h-screen overflow-hidden">
					<div
						className="relative h-screen overflow-hidden "
					>
						{backgroundImageWeb?.length > 0 &&
							backgroundImageWeb.map((img, index) => {
								const isActive = currentImageIndexWeb === index;

								return (
									<React.Fragment key={index}>
										{/* preload image */}
										<img
											src={newImgUrl + img}
											className="hidden"
											onLoad={() => setIsImageLoaded(false)}
											alt=""
										/>

										{/* background */}
										<div
											className={`absolute inset-0 crossFade__image-bg
            ${isActive ? 'crossFade__image-bg--active' : ''}
            transition-all duration-500
            ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"}
          `}
											style={{
												backgroundImage: `url("${newImgUrl + img}")`,
												backgroundSize: 'cover',
												backgroundPosition: 'center',
											}}
										/>
									</React.Fragment>
								);
							})}

					</div>
					<div className="absolute inset-0 ms-auto pt-10 flex flex-col bg-black/70 max-w-[450px] h-full item-center justify-center">
						<PageHeading title={"Our Family"} color={true} />
						<div className=" py-10 flex flex-col justify-center items-center gap-[55px] mx-[80px]">
							<div
								className=" w-full bg-white rounded-3xl overflow-hidden border-[3px] border-white cursor-pointer whiteripple"
								onClick={() => handleSlideIn("groomFamilyMembers")}
							>
								<div clicked={() => { }}>
									<div className="flex justify-between items-center border-[3px] border-white ">
										<div className="flex-1">
											<div className="w-full aspect-[5/6] overflow-hidden " style={{ borderRadius: '20px 0px 0px 20px' }}>
												<img
													src={basicDetails?.groomBg ? `${newImgUrl + basicDetails?.groomBg}` : ""}
													alt=""
													className={`
									transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
														}
									`}
													onLoad={() => setIsImageLoaded(false)}
												/>
											</div>
										</div>
										<div className="flex-1">
											<div className="mx-auto flex flex-col items-center justify-center">
												<BrideIcon
													fill="#262626"
													width="65"
													height="65"
												/>
												<h5 className="text-[#262626] text-center font-semibold text-[17px] px-2">
													{basicDetails && basicDetails.groomHeading}
												</h5>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div
								className="w-full bg-white rounded-3xl border-[3px] border-white overflow-hidden cursor-pointer whiteripple"
								onClick={() => handleSlideIn("brideFamilyMembers")}
							>
								<div clicked={() => { }}>
									<div className="flex justify-between items-center border-[3px] border-white">
										<div className="flex-1">
											<div className="w-full aspect-[5/6] overflow-hidden " style={{ borderRadius: '20px 0px 0px 20px' }}>
												<img
													src={basicDetails?.brideBg ? `${newImgUrl + basicDetails?.brideBg}` : ""}
													alt=""
													className={`
									transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
														}
									`}
													onLoad={() => setIsImageLoaded(false)}

												/>
											</div>
										</div>
										<div className="flex-1">
											<div className="mx-auto flex flex-col items-center justify-center">
												<GroomIcon
													fill="#262626"
													width="65"
													height="65"
												/>
												<h5 className="text-[#262626] text-center font-semibold text-[17px] px-2">
													{basicDetails && basicDetails.brideHeading}
												</h5>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="sm:hidden h-svh flex flex-col justify-between gap-0">
				<div className="relative h-screen overflow-hidden">
					{backgroundImageMob?.length > 0 &&
						backgroundImageMob.map((img, index) => (
							<img
								src={newImgUrl + img}
								className={`w-full h-full relative z-[-1] object-cover crossFade__image ${currentImageIndexMob === index ? 'crossFade__image--active' : ''
									}
												 transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
									}
						
												`}
								onLoad={() => setIsImageLoaded(false)}
								alt=""
							/>
						))}
					<div
						className="top-0 w-full h-full py-[30px] px-[30px] opacity-90 absolute flex flex-col justify-center items-center text-center"
						style={{
							background:
								"linear-gradient(0deg, rgba(0,0,0,0.9) 0%, rgba(59,59,59,0.4) 50%, rgba(0,0,0,0.9) 100%)",
						}}
					>
						<div className="w-full h-full flex justify-center items-center border-[3px] border-white text-center">
							<h1 className="style-script-regular text-white text-[60px] font-['Baby_Giovani_Script'] m-0 p-0">
								Our Family
							</h1>
						</div>
					</div>
				</div>
				<div className="flex justify-around items-center gap-[1.25rem] m-[1rem]">
					<div
						className="relative w-full whiteripple"
						onClick={() => handleSlideIn("groomFamilyMembers")}
					>
						<CustomCard>
							<img
								src={basicDetails?.groomBg ? `${newImgUrl + basicDetails?.groomBg}` : ""}
								className={`object-cover w-full aspect-[2/3] relative z-[-1] transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
									}`}
								alt=""
								srcset=""
							/>
							<div className="absolute top-0 w-full h-full flex flex-col justify-end items-center pb-[1.25rem] text-center bg-black/35">
								{/* <img src={CameraIcon} alt="" width={50} /> */}
								<GroomIcon fill="white" width="75" />
								<h5 className="text-white font-semibold text-[17px]">
									{basicDetails && basicDetails.groomHeading}
								</h5>
							</div>
						</CustomCard>
					</div>
					<div
						className="relative w-full "
						onClick={() => handleSlideIn("brideFamilyMembers")}
					>
						<CustomCard>
							<img
								src={basicDetails?.brideBg ? `${newImgUrl + basicDetails?.brideBg}` : ""}
								className={`object-cover w-full aspect-[2/3] relative z-[-1] transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
									}`}
								alt=""
							/>
							<div className="absolute top-0 w-full h-full flex flex-col justify-end items-center pb-[1.25rem] text-center bg-black/35">
								{/* <img src={videoIcon} alt="" width={50} /> */}
								<BrideIcon fill="white" width="75" />
								<h5 className="text-white font-semibold text-[17px]">
									{basicDetails && basicDetails.brideHeading}
								</h5>
							</div>
						</CustomCard>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Family;
